// export const BASE_ENDPOINT: string = 'https://3.134.239.31/prod';
export const BASE_ENDPOINT: string = 'https://3.134.239.31/qa';
// export const BASE_ENDPOINT: string = 'http://localhost:20001';
export const API_V1: string = `${BASE_ENDPOINT}/api/v1`;

export const API_V1_AUTH: string = `${API_V1}/auth`;
export const API_V1_ACCOUNT: string = `${API_V1}/account`;

export const API_V1_CUSTOMER: string = `${API_V1}/customer`;
export const API_V1_PRODUCT: string = `${API_V1}/product`;
export const API_V1_KARDEX_ENTRY: string = `${API_V1}/kardex-entry`;
export const API_V1_TRANSACTION: string = `${API_V1}/transaction`;
export const API_V1_MENU: string = `${API_V1}/menu`;

export const APP_VERSION: string = '2.0.0';
